import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/TitleController/CreateTitle";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateTitle({ title, onClose, onSuccess }) { // Add team prop
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ Title: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (title) {
            setFormData({ Title: title.Title });
        } else {
            setFormData({ Title: '' }); // Clear form data when switching to add mode
        }
    }, [title]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission
        try {
            if (title) {
                formData.ID = title.ID;
            } else {
                formData.ID = 0;
            }
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const redirectUserList = () => {
                navigate('/AdministrationSetting?saved=true');
            };
            handleSubmit(event, formData, setFormData, setErrors, () => {
                redirectCallback();
                onSuccess(); // Call onSuccess to reload data
                onClose(); // Close the modal on successful form submission
            }, () => {
                redirectUserList();
                onSuccess(); // Call onSuccess to reload data
                onClose(); // Close the modal on successful form submission
            });
        } catch (error) {
            console.error('Error saving Team:', error);
            setErrors({ submit: 'Error saving team. Please try again.' });
        }
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="titleModal" tabIndex="-1" aria-labelledby="titleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="titleModalLabel">{title ? 'Edit Title' : 'Create Title'}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Title</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="Title" value={formData.Title} onChange={handleFieldChange} />
                                        {errors.Title && <div style={{ color: 'red' }}>{errors.Title}</div>}
                                    </div>
                                </div>
                                {errors.submit && <div className="alert alert-danger">{errors.submit}</div>}
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {title ? ' Update' : ' Save'}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateTitle;
